module.exports = __webpack_public_path__ + "img/Mint-Poster.6d1cbc8b.png";